module.exports = __webpack_public_path__ + "img/logo@3x.966b4825.png";